module.exports = __webpack_public_path__ + "assets/img/dailyTask-bottom-right-left.c3b9a9ca.png";